import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { UserAccessProvider } from "context/UserAccessContext";
import { MultiStepFormProvider } from "features/loanApplications/context/MultiStepFormContext";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <Router>
    <AuthProvider>
      <UserAccessProvider>
        <MultiStepFormProvider>
          <App />
        </MultiStepFormProvider>
      </UserAccessProvider>
    </AuthProvider>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
